exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-datepicker-input {\n  opacity: 0;\n  position: absolute;\n  left: -1px;\n  height: 40px;\n  border: none; }\n\n.pe-none {\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/form-components/form-datepicker/form-datepicker.component.scss
// module id = ../../../../../src/app/components/common/form-components/form-datepicker/form-datepicker.component.scss
// module chunks = 0